<template>
	<el-dialog title="未完事项" :visible="true" width="40%" :close-on-click-modal="false" @close="$emit('close')">
		<el-input clearable type="textarea" :autosize="{ minRows:5}" v-model="text" placeholder="请输入内容..."
			style="margin-bottom:20px;" show-word-limit :maxlength="120"></el-input>
		<div slot="footer" class="dialog-footer" style="text-align:right">
			<el-button :disabled="loading" @click="$emit('close')">取 消</el-button>
			<el-button type="primary" :loading="loading" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
import {book_index} from '@/api/book'
export default {
    props:['txt','book_id','index'],
	data(){
		return {
			text:this.txt||'',
			loading:false
		}
	},
	methods: {
		submit(){
			this.loading=true
			book_index.setRemark({book_id:this.book_id,book_page_index:this.index,content:this.text}).then(res=>{
				this.$message.success('设置成功')
				this.loading=false
				this.$emit('success',this.text)
			})
		}	
	},
}
</script>


// WEBPACK FOOTER //
// src/views/book/remark.vue